var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5786 7.47536C13.4251 4.58309 11.0312 2.28516 8.1007 2.28516C6.53867 2.28516 5.08116 2.94211 4.04854 4.07311C3.8783 4.25957 3.89145 4.54871 4.0779 4.71895C4.26435 4.88918 4.5535 4.87603 4.72373 4.68958C5.5849 3.74637 6.7983 3.19944 8.1007 3.19944C10.4791 3.19944 12.4333 5.01579 12.6518 7.33704L12.1195 6.89358L12.0691 6.85708C11.8783 6.73749 11.6238 6.77432 11.4756 6.95212C11.314 7.14607 11.3402 7.43433 11.5341 7.59596L13.1982 8.9827L14.8623 7.59596L14.9073 7.55304C15.0593 7.38694 15.069 7.12991 14.9208 6.95212L14.8779 6.90713C14.7118 6.7551 14.4548 6.74542 14.277 6.89358L13.5786 7.47536ZM1.41847 8.58962C1.27031 8.41183 1.27998 8.1548 1.43202 7.9887L1.477 7.94578L3.14108 6.55905L4.80517 7.94578C4.99912 8.10741 5.02533 8.39567 4.8637 8.58962C4.71554 8.76742 4.46097 8.80425 4.27018 8.68466L4.21986 8.64816L3.53966 8.08155C3.69937 10.4614 5.68038 12.3423 8.1007 12.3423C9.40295 12.3423 10.6162 11.7955 11.4774 10.8525C11.6476 10.666 11.9368 10.6529 12.1232 10.8231C12.3097 10.9934 12.3228 11.2825 12.1525 11.469C11.1199 12.5998 9.66256 13.2566 8.1007 13.2566C5.20712 13.2566 2.83681 11.0163 2.62968 8.17554L2.06231 8.64816C1.88452 8.79632 1.62748 8.78664 1.46139 8.63461L1.41847 8.58962Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.8625f3f15ebba56b77156826d1ab5a8f.svg";
export { ForwardRef as ReactComponent };